import { px } from 'd2/utils/style'
import makeStyles from 'd2/hooks/tss/makeStyles'

const TAG_MARGIN = 4

const styles = () => ({
  margin: {
    marginLeft: px(TAG_MARGIN),
  },
} as const)

export default makeStyles({
  name: 'AudioTrackTags',
})(styles)
